import Lookup from 'src/componentes/select2';

const OrientacaoSexualLookup = ({ ...rest }) => (
  <Lookup
    labelKey="nome"
    valueKey="id"
    url="/OrientacaoSexualLookup"
    {...rest}
  />
);

export default OrientacaoSexualLookup;
